import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { ClassNameMap } from '@mui/styles';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    bottom: 0,
    position: 'fixed',
    zIndex: 11,
    width: '100%'
  }
}));

type DrawerFooterProps = { classes?: ClassNameMap; children?: React.ReactNode };

export const DrawerFooter: React.FC<DrawerFooterProps> = ({
  classes,
  children,
  ...rest
}: DrawerFooterProps) => {
  const cls = useStyles({ classes });
  return (
    <div className={cls.root} data-testid="drawer-footer" {...rest}>
      {children}
    </div>
  );
};
